import { Action } from '@ngrx/store';
import { Update } from '@ngrx/entity';
import { GateWay } from '../gateway.model';

export enum GateWayAttributeActionTypes {
  UpsertMgtAttribute = '[GateWay] Upsert Mgt Attribute',
  ReadMgtAttribute = '[GateWay] Read Mgt Attribute',
  ReadMgtAttributeFail = '[GateWay] Read Mgt Attribute Fail',
  UpsertAttribute = '[GateWay] Upsert Attribute',
  ReadAttribute = '[GateWay] Read Attribute',
  ReadAttributeFail = '[GateWay] Read Attribute Fail',
  AddMgtAttribute = '[GateWay] Add Mgt Attribute',
  UpdateMgtAttribute = '[GateWay] Update Mgt Attribute',
  DeleteMgtAttribute = '[GateWay] Delete Mgt Attribute',
}

export class ReadMgtAttribute implements Action {
  readonly type = GateWayAttributeActionTypes.ReadMgtAttribute;

  constructor(public payload: any = null) {}
}
export class UpsertMgtAttribute implements Action {
  readonly type = GateWayAttributeActionTypes.UpsertMgtAttribute;

  constructor(public payload: any) {}
}
export class ReadMgtAttributeFail implements Action {
  readonly type = GateWayAttributeActionTypes.ReadMgtAttributeFail;

  constructor(public payload: any = null) {}
}
export class ReadAttribute implements Action {
  readonly type = GateWayAttributeActionTypes.ReadAttribute;

  constructor(public payload: any = null) {}
}
export class UpsertAttribute implements Action {
  readonly type = GateWayAttributeActionTypes.UpsertAttribute;

  constructor(public payload: any) {}
}
export class ReadAttributeFail implements Action {
  readonly type = GateWayAttributeActionTypes.ReadAttributeFail;

  constructor(public payload: any = null) {}
}
export class AddMgtAttribute implements Action {
  readonly type = GateWayAttributeActionTypes.AddMgtAttribute;

  constructor(public payload: any = null) {}
}
export class UpdateMgtAttribute implements Action {
  readonly type = GateWayAttributeActionTypes.UpdateMgtAttribute;

  constructor(public payload: any = null) {}
}
export class DeleteMgtAttribute implements Action {
  readonly type = GateWayAttributeActionTypes.DeleteMgtAttribute;

  constructor(public payload: any = null) {}
}



export type GateWayAttributeActions =
ReadMgtAttribute
 | UpsertMgtAttribute
 | ReadMgtAttributeFail
 | ReadAttribute
 | UpsertAttribute
 | ReadAttributeFail
 | AddMgtAttribute
 | UpdateMgtAttribute
 | DeleteMgtAttribute
